import React from "react";
import Slider from "react-slick";
import styled from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Typography } from "@mui/material";
import GIF from "../Assets/better-luck-next-time-good-luck.gif";

const CompanySlider = ({ score, view }) => {
  const score_package_map = {
    0: "Unplaced",
    1: "3-5",
    2: "5-10",
    3: "10-20",
    4: "20+",
  };

  const settings = {
    speed: 2000,
    autoplay: true,
    infinite: true,
    autoplaySpeed: 0,
    slidesToShow: view === "mobile" ? 2.2 : 2.5,
    cssEase: "linear",
    arrows: false,
    dots: false,
  };

  const changefilename = (fname) => {
    const path = `./../referrals_logo/${
      score_package_map[score]
    }/${fname.substring(2)}`;

    return path;
  };

  const images = () => {
    if (score == 0) {
      return [];
    }

    let path = {};
    if (score == 1) {
      path = require.context(
        "../../../public/referrals_logo/3-5/",
        false,
        /\.png$/
      );
    } else if (score == 2) {
      path = require.context(
        "../../../public/referrals_logo/5-10/",
        false,
        /\.png$/
      );
    } else if (score == 3) {
      path = require.context(
        "../../../public/referrals_logo/10-20/",
        false,
        /\.png$/
      );
    } else if (score == 4) {
      path = require.context(
        "../../../public/referrals_logo/20+/",
        false,
        /\.png$/
      );
    }
    return path.keys();
  };

  const name = images();
  const fnames = name.map(changefilename);

  return (
    <CompanySlider_main>
      <Typography
        variant="h3"
        sx={{
          margin: "3rem 0",
          textAlign: "center",
          color: "white",
          fontSize: "2rem",
          fontWeight: "bold",
          "@media (max-width:480px)": {
            fontSize: "1.8rem",
          },
        }}
      >
        Companies you are ready for
      </Typography>
      {score == 0 && (
        <div style={{ textAlign: "center" }}>
          <img src={GIF} width={"55%"} />
        </div>
      )}
      {score > 0 && (
        <Slider {...settings} style={{ margin: "7% 0" }}>
          {fnames.map((fname, index) => (
            <div key={index} style={{ width: "3rem" }}>
              <img
                src={fname}
                style={{
                  objectFit: "fill",
                  width: view === "mobile" ? "5rem" : "10rem",
                  height: view === "mobile" ? "5rem" : "10rem",
                }}
                alt=""
              />
            </div>
          ))}
        </Slider>
      )}
    </CompanySlider_main>
  );
};

const CompanySlider_main = styled.div`
  margin-bottom: 2.5rem;
  display: flex;
  flex-direction: column;
  position: relative;
  .slick-slide {
    &:focus,
    a {
      outline: none;
    }
  }
  .slick-slide div {
    transition-timing-function: linear !important;
    outline: none;
  }
`;

export default CompanySlider;
